import { generateUseContext } from '@guiker/react-context'

import { BookingContext } from './BookingContext'

export const useBookingContext = generateUseContext(BookingContext)
